module.exports = __webpack_public_path__ + "static/media/hamburger.916bf09d.svg";